module.exports = __webpack_public_path__ + "static/media/vectorImg.c18e383e.png";